import { readFile, rename, writeFile } from "node:fs/promises";
import { deserializeStateV1, serializeStateV1 } from "./serde.js";
export class JsonFileStateStore {
    path;
    constructor(path) {
        this.path = path;
    }
    async load() {
        try {
            const raw = await readFile(this.path, "utf8");
            return deserializeStateV1(raw);
        }
        catch {
            // File missing or invalid: treat as no state.
            return null;
        }
    }
    async save(next) {
        const tempPath = `${this.path}.tmp-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const payload = serializeStateV1(next);
        await writeFile(tempPath, payload, "utf8");
        // Best-effort atomic replace on most platforms (write temp in same directory, then rename).
        await rename(tempPath, this.path);
    }
}
